import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

/* Ayuda rápida del correo (M31, auditoría 2026-10-02): antes solo existía el tutorial de carpetas.
   Se abre con «?» o desde el menú de la cuenta. Solo dice lo que el producto hace hoy. */
const ATAJOS = [
  ['C', 'Redactar un correo nuevo'],
  ['Ctrl / ⌘ + K', 'Buscar correo, personas o acciones'],
  ['Ctrl / ⌘ + Enter', 'Enviar el correo que estás escribiendo'],
  ['J / K', 'Abrir el correo siguiente / anterior'],
  ['R · A · F', 'Responder, responder a todos o reenviar el correo abierto'],
  ['E · #', 'Archivar o eliminar el correo abierto'],
  ['Tab y Enter', 'Moverte por la bandeja y abrir un correo'],
  ['?', 'Abrir esta ayuda'],
];

// Atajos del Calendario (CalendarPage.jsx): antes no se documentaban en ningún sitio (K12)
const ATAJOS_CALENDARIO = [
  ['C', 'Crear un evento'],
  ['T', 'Ir a hoy'],
  ['D · S · M · A', 'Vista de día, semana, mes o agenda'],
  ['← / → (o J / K)', 'Periodo anterior o siguiente'],
];

const PREGUNTAS = [
  ['¿Dónde queda lo que archivo?', 'En «Todos», que reúne todo tu correo. Archivar lo saca de Recibidos sin borrarlo.'],
  ['¿Puedo arrepentirme de un envío?', 'Sí: al pulsar Enviar tienes 8 segundos para «Deshacer» y el mensaje vuelve al redactor.'],
  ['¿Qué son «Por responder» y «En espera»?', '«Por responder» junta los correos que esperan tu respuesta. «En espera» reúne lo que programaste para enviar más tarde y lo que pospusiste.'],
  ['Me sale una franja roja de contraseña rechazada', 'Tu proveedor de correo ya no acepta la contraseña guardada (casi siempre porque se cambió). Pulsa «Volver a entrar» y escribe la contraseña actual de tu buzón.'],
  ['Para buscar solo en una parte', 'Escribe de: ana, para: juan o asunto: factura en el buscador.'],
];

export default function AyudaRapida({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[520px] max-h-[85vh] overflow-y-auto" data-testid="ayuda-rapida">
        <DialogHeader>
          <DialogTitle>Ayuda</DialogTitle>
          <DialogDescription style={{ color: 'var(--text-2)' }}>Atajos de teclado y preguntas frecuentes.</DialogDescription>
        </DialogHeader>
        <section aria-labelledby="ayuda-atajos">
          <h3 id="ayuda-atajos" className="text-sm font-semibold mb-2" style={{ color: 'var(--text)' }}>Atajos de teclado</h3>
          <dl className="space-y-1.5">
            {ATAJOS.map(([tecla, que]) => (
              <div key={tecla} className="flex items-center gap-3 text-sm">
                <dt className="shrink-0"><kbd className="px-1.5 py-0.5 rounded-md text-xs font-mono" style={{ background: 'var(--hover)', border: '1px solid var(--line-2)', color: 'var(--text)' }}>{tecla}</kbd></dt>
                <dd style={{ color: 'var(--text-2)' }}>{que}</dd>
              </div>
            ))}
          </dl>
        </section>
        <section aria-labelledby="ayuda-atajos-cal" className="mt-4">
          <h3 id="ayuda-atajos-cal" className="text-sm font-semibold mb-2" style={{ color: 'var(--text)' }}>En el Calendario</h3>
          <dl className="space-y-1.5">
            {ATAJOS_CALENDARIO.map(([tecla, que]) => (
              <div key={tecla} className="flex items-center gap-3 text-sm">
                <dt className="shrink-0"><kbd className="px-1.5 py-0.5 rounded-md text-xs font-mono" style={{ background: 'var(--hover)', border: '1px solid var(--line-2)', color: 'var(--text)' }}>{tecla}</kbd></dt>
                <dd style={{ color: 'var(--text-2)' }}>{que}</dd>
              </div>
            ))}
          </dl>
        </section>
        <section aria-labelledby="ayuda-preguntas" className="mt-4">
          <h3 id="ayuda-preguntas" className="text-sm font-semibold mb-2" style={{ color: 'var(--text)' }}>Preguntas frecuentes</h3>
          <div className="space-y-3">
            {PREGUNTAS.map(([p, r]) => (
              <div key={p}>
                <div className="text-sm font-medium" style={{ color: 'var(--text)' }}>{p}</div>
                <p className="text-sm" style={{ color: 'var(--text-2)', lineHeight: 1.55 }}>{r}</p>
              </div>
            ))}
          </div>
        </section>
      </DialogContent>
    </Dialog>
  );
}
